import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Auth state for the PWA.
 *
 *   accessToken  — short-lived JWT (60 min). NOT persisted; re-fetched on
 *                  app start via /auth/refresh using the persisted refresh
 *                  token. In-memory only.
 *   refreshToken — long-lived JWT (7 days). Persisted to localStorage so the
 *                  PWA can pick up where the user left off after an OS-level
 *                  app restart.
 *   user         — the user object as returned by /auth/login. Persisted so
 *                  the home screen can show "Hi, ${user.name}" without an
 *                  extra round-trip on every cold start.
 *
 * The trust-device token (separate, longer-lived 30-day token) lives in
 * IndexedDB via lib/trust-device-store.js, not here.
 */
export const useAuthStore = create(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,

      setTokens: ({ access, refresh, user }) =>
        set({ accessToken: access, refreshToken: refresh, user }),

      setAccessToken: (access) => set({ accessToken: access }),

      clear: () => set({ accessToken: null, refreshToken: null, user: null }),
    }),
    {
      name: 'xenergy-pwa-auth',
      // Don't persist accessToken — short-lived, refreshed on demand.
      partialize: (state) => ({
        refreshToken: state.refreshToken,
        user: state.user,
      }),
    },
  ),
);
